import { render, staticRenderFns } from "./Productpay.vue?vue&type=template&id=1501a3ec&scoped=true"
import script from "./Productpay.vue?vue&type=script&lang=js"
export * from "./Productpay.vue?vue&type=script&lang=js"
import style0 from "./Productpay.vue?vue&type=style&index=0&id=1501a3ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1501a3ec",
  null
  
)

export default component.exports